import { z } from "zod";

export const uuid = z.string().uuid();
export const email = z.string().email().toLowerCase().trim();
export const nonEmpty = z.string().trim().min(1);
export const optionalString = z.string().trim().optional();
export const url = z.string().url();
export const isoDate = z.string().datetime({ offset: true });

// Strong password: ≥12 chars, at least 1 lower, 1 upper, 1 digit.
export const strongPassword = z
  .string()
  .min(12, "Password must be at least 12 characters")
  .regex(/[a-z]/, "Must include a lowercase letter")
  .regex(/[A-Z]/, "Must include an uppercase letter")
  .regex(/\d/, "Must include a digit");
